export const ConfigureVehicle = () => {
  // TODO: create configure vehicle page
  return <></>
}
